module.exports = __webpack_public_path__ + "static/media/2.a8a6771c.webp";